import React from 'react';
import {
  Col, Grid, Panel, Row,
} from 'rsuite';

import { IMPORT_ALZA_ATTRIBUTES_URL, importProducts } from '../../api/products';
import FileUploadCsv from '../FileUploadCsv';

export default function AlzaAttributes() {
  async function uploadFile(file: Blob, fileName: string) {
    const data = new FormData();
    data.append('attachment', file, fileName);
    const response = await importProducts(IMPORT_ALZA_ATTRIBUTES_URL, data);

    return response.data;
  }

  return (
    <Panel>
      <Grid fluid>
        <Row>
          <Col xs={24}>
            <h6>import</h6>
            <FileUploadCsv className="mt-5" getUploadResult={(file, fileName) => uploadFile(file, fileName)} />
          </Col>
        </Row>
      </Grid>
    </Panel>
  );
}
